import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

const EXTENDED_SUM_LIST = [
  { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.0', value: '0' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.20', value: '20000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.30', value: '30000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.40', value: '40000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.50', value: '50000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.75', value: '75000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.100', value: '100000' },
];

export const TRAILER_HOME = {
  nickname: 'PRODUCTS.TRAILER_HOME.shortname',
  properties: [
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'BRANN_TYVERI' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN', value: 'BRANN' },
        ]
      }
    },
    {
      name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      TRAILER_HOME: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/[a-zA-Z]{2}\d{4}/)
      ]]
    },
    { name: 'tffVehicleBrand', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO' },
    { name: 'tffRegisteredOnOwnerFirstTime', key: 'TFF_REGISTERED_ON_OWNER_FIRST_TIME', group: 'INSURANCE_INFO' },
    {
      name: 'trailerType', key: 'TRAILER_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.CAMPING_TRAILER', value: 'CAMPING_TRAILER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.TENT_PLATFORM', value: 'TENT_PLATFORM' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.PASSENGER_CAR_TRAILER', value: 'PASSENGER_CAR_TRAILER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.TRACTOR_TRAILER', value: 'TRACTOR_TRAILER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.MOTORCYCLE_TRAILER', value: 'MOTORCYCLE_TRAILER' },
        ]
      }
    },
    {
      name: 'trailerMarketValue', key: 'MARKET_VALUE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      TRAILER_MARKET_VALUE_RANGE_TO_1500000: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/),
        Validators.min(1),
        Validators.max(1500000)
      ]]
    },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.7.5', value: '7500' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.15', value: '15000' }
        ]
      },
    },
    {
      name: 'vehicleMortage', key: 'VEHICLE_MORTAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'includeExtendedSumFixedEquipment', key: 'INCLUDE_EXTENDED_SUM_FIXED_EQUIPMENT', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isIncludeExtendedSumFixedEquipmentCheck: true,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'contentsSumInsured', key: 'EXTENDED_SUM_AMOUNT', group: 'INSURANCE_INFO',
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: EXTENDED_SUM_LIST
      }
    },
    {
      name: 'includeExtendedSumMovables', key: 'INCLUDE_EXTENDED_SUM_MOVABLES', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isIncludeExtendedSumMovablesCheck: true,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'productSumInsured', key: 'EXTENDED_SUM_AMOUNT', group: 'INSURANCE_INFO',
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: EXTENDED_SUM_LIST
      }
    },
    {
      name: 'isTrailerStationary', key: 'IS_TRAILER_STATIONARY', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.FIELDS_OF_USE.FIXED_SPOT', value: 'FIXED_SPOT' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.FIELDS_OF_USE.DRIVEN_IN_TRAFFIC', value: 'DRIVEN_IN_TRAFFIC' },
        ]
      }
    },
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/)
      ]]
    },
    { name: 'ofvFirstTimeRegYear', key: 'OFV_FIRST_TIME_REG_YEAR', group: 'OBJECT_INFO' },
  ],
  icon: 'trailer-home'
};
